var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedInvoiceReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 21.6667H18C17.7917 21.6667 17.6667 21.8333 17.6667 22V22.6667C17.6667 22.875 17.7917 23 18 23H21.3333C21.5 23 21.6667 22.875 21.6667 22.6667V22C21.6667 21.8333 21.5 21.6667 21.3333 21.6667ZM24.375 9.08333L20.875 5.625C20.5 5.25 20 5 19.5 5H10.9583C9.875 5.04167 9 5.91667 9 7.04167V24.375C9 25.4583 9.875 26.3333 10.9583 26.3333H22.9583C24.0833 26.3333 25 25.4583 25 24.375V10.5C25 10 24.75 9.45833 24.375 9.08333ZM19.625 7.16667L22.8333 10.375H19.625V7.16667ZM23 24.375H10.9583V7.04167H17.625V11.375C17.625 11.9167 18.0833 12.375 18.625 12.375H23V24.375ZM12.6667 9.66667H16C16.1667 9.66667 16.3333 9.54167 16.3333 9.33333V8.66667C16.3333 8.5 16.1667 8.33333 16 8.33333H12.6667C12.4583 8.33333 12.3333 8.5 12.3333 8.66667V9.33333C12.3333 9.54167 12.4583 9.66667 12.6667 9.66667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.6667H21",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.6667C17 23.9805 14.3137 26.6667 11 26.6667C7.68629 26.6667 5 23.9805 5 20.6667C5 17.353 7.68629 14.6667 11 14.6667C14.3137 14.6667 17 17.353 17 20.6667Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 25.1636C8.5 25.1636 6.5 23.1594 6.5 20.6541C6.5 18.1802 8.5 16.1447 11 16.1447C13.4688 16.1447 15.5 18.1802 15.5 20.6541C15.5 23.1594 13.4688 25.1636 11 25.1636ZM13 18.7439C12.9063 18.6499 12.75 18.6499 12.6562 18.7439L10.4688 20.9047L9.53125 19.9339C9.4375 19.8399 9.28125 19.8399 9.1875 19.9339L8.59375 20.5289C8.5 20.6228 8.5 20.7794 8.59375 20.8733L10.2813 22.5957C10.375 22.6897 10.5313 22.6897 10.625 22.5957L13.5937 19.6833C13.6875 19.5894 13.6875 19.4328 13.5937 19.3076L13 18.7439Z",
    fill: "#F15A29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedInvoiceReceived);
export default __webpack_public_path__ + "static/media/Selected Invoice Received.4a2e7756f997ee277af788d8f1e35baf.svg";
export { ForwardRef as ReactComponent };